(() => {
  const RUNTIME_NAME = 'MarineMaxProductAdditionalFeatures';
  const SECTION_SELECTOR = '[data-iiq-additional-features]';
  const TEMPLATE_SELECTOR = '[data-iiq-additional-features-template]';
  const GRID_SELECTOR = '[data-iiq-additional-features-grid]';

  const existingRuntime = window[RUNTIME_NAME];
  if (existingRuntime?.initialize) {
    existingRuntime.initialize();
    return;
  }

  const collectSections = (root) => {
    if (!root) return [];

    const sections = [];
    if (typeof root.matches === 'function' && root.matches(SECTION_SELECTOR)) {
      sections.push(root);
    }
    if (typeof root.querySelectorAll === 'function') {
      sections.push(...root.querySelectorAll(SECTION_SELECTOR));
    }

    return [...new Set(sections)];
  };

  const initializeSection = (section) => {
    const template = section.querySelector(TEMPLATE_SELECTOR);
    const grid = section.querySelector(GRID_SELECTOR);

    if (!template?.content || !grid) return false;
    if (grid.childElementCount > 0) return true;

    const source = template.content.cloneNode(true);
    const sourceChildren = Array.from(source.children);
    const output = section.ownerDocument.createElement('div');

    const createGroup = () => {
      const group = section.ownerDocument.createElement('div');
      group.className = 'iiq-additional-features__group';
      output.appendChild(group);
      return group;
    };

    const createHeadingGroup = (headingText) => {
      const group = createGroup();
      const heading = section.ownerDocument.createElement('h3');
      heading.className = 'iiq-additional-features__group-title';
      heading.textContent = headingText;
      group.appendChild(heading);
      return group;
    };

    const textLines = String(source.textContent || '')
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);

    let currentGroup = null;

    if (!sourceChildren.length && textLines.length) {
      currentGroup = createGroup();
      textLines.forEach((line) => {
        const item = section.ownerDocument.createElement('p');
        item.className = 'iiq-additional-features__item';
        item.textContent = line;
        currentGroup.appendChild(item);
      });
    }

    sourceChildren.forEach((element) => {
      const strong = element.querySelector('strong');
      const headingText = element.textContent.trim();
      const isHeadingParagraph =
        element.tagName === 'P' && strong && headingText === strong.textContent.trim();
      const isHeadingTag = /^H[2-6]$/.test(element.tagName);

      if (isHeadingParagraph || isHeadingTag) {
        currentGroup = createHeadingGroup(headingText);
        return;
      }

      if (!currentGroup) currentGroup = createGroup();

      const clone = element.cloneNode(true);
      clone.classList.add('iiq-additional-features__item');
      currentGroup.appendChild(clone);
    });

    const renderedGroups = Array.from(output.children);
    if (!renderedGroups.length) {
      section.remove();
      return false;
    }

    grid.replaceChildren(...renderedGroups);
    return true;
  };

  const initialize = (root = document) =>
    collectSections(root).reduce(
      (initializedCount, section) => initializedCount + Number(initializeSection(section)),
      0,
    );

  window[RUNTIME_NAME] = { initialize };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
